import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import MisHeader from '../../Components/MisHeader'
import * as utils from '../../Ranking/ranking.utils'

/**
 *  ProfileScreen Component.
 */
class ProfileScreen extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      growOutClass: '',
    }
  }

  removeScreen() {
    const { removeScreen } = this.props

    this.setState({ growOutClass: 'bounceOut-animation' })
    setTimeout(() => removeScreen('profile_screen'), 1000)
  }

  getBattleMessage(battle) {
    const { userData } = this.props
    const { resolvedForDefender, createdBy, winnerId } = battle
    let status = ''
    let resultClass = ''
    let battleAtacked = createdBy == userData.id ? 'attacking' : 'attacked'
    if (!resolvedForDefender) {
      status = createdBy == userData.id ? 'waiting' : 'nextSession'
    } else {
      status = winnerId == userData.id ? 'won' : 'lost'
      resultClass = winnerId == userData.id ? 'darkgreen' : 'red'
    }
    return { battleAtacked, status, resultClass }
  }

  renderListItem(battle) {
    const { players, userData, intl, currentUser, rankingObfuscated } = this.props
    const { building } = battle
    const message = this.getBattleMessage(battle)

    const rivalId = battle.players.find((user) => user != userData.id)
    const rivalData = players.find((user) => rivalId == user.licenseId)
    const buildingName = intl.formatMessage({ id: `buildings.${building.name}` })
    let obfuscated = rankingObfuscated == 'undefined' ? 'normal' : rankingObfuscated
    let name =
      (obfuscated == 'obfuscated'
        ? utils.obfuscated(rivalData.name, currentUser)
        : obfuscated == 'alias'
        ? rivalData.alias
        : rivalData.name) || 'name'
    return (
      <div key={battle.id} className="mis--profile__row">
        <div className="mis--profile__info">
          <div className="text">
            <FormattedMessage
              id={`profile.battles.${message.battleAtacked}`}
              values={{ colonyName: rivalData.colonyName, userName: name }}
            />
          </div>
          <div className="text">
            <FormattedMessage
              id={`profile.battles.bet`}
              values={{ level: building.level, name: buildingName }}
            />
          </div>
        </div>
        <div className={`result ${message.resultClass}`}>
          <FormattedMessage id={`profile.battles.${message.status}`} />
        </div>
      </div>
    )
  }
  /**
   *  Render the compon0ent
   */
  render() {
    const { battles, groupData, user } = this.props
    const { growOutClass } = this.state
    const topic = groupData.topic || user.licenseData.topic ? user.licenseData.topic : null

    return (
      <div
        className={`container background background--mina ${growOutClass} ${
          !growOutClass ? 'growIn-animation' : ''
        } z-index1`}
      >
        <div className="content">
          <div className="mis">
            <div className="position--absolute left top z-index1">
              <div onClick={() => this.removeScreen()} className="btn--back">
                <span className="icon-back"> </span>
              </div>
            </div>
            <MisHeader />
            <div className="mis--profile">
              <div className="mis--profile__table">
                <div className="mis--profile__header">
                  <span>
                    <FormattedMessage id={`profile.battles.title`} />
                  </span>
                  {battles.length > 0 ? <span className="num">{battles.length}</span> : null}
                </div>
                {battles.length > 0 ? (
                  <div className="mis--profile__body">
                    {battles.map((item) => this.renderListItem(item))}
                  </div>
                ) : (
                  <div className="mis--profile__body void">
                    <span className="icon-desafio"> </span>
                    <FormattedMessage id="profile.battles.empty" />
                  </div>
                )}
              </div>
              {topic ? (
                <div className="mis--profile__footer">
                  <b>MARS:</b> {topic}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

ProfileScreen.propTypes = {
  removeScreen: PropTypes.func,
  userData: PropTypes.object,
  battles: PropTypes.array,
  players: PropTypes.array,
  groupData: PropTypes.object,
  currentUser: PropTypes.object,
  user: PropTypes.object,
  rankingObfuscated: PropTypes.string,
}
export default ProfileScreen
